import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { AdminLayout } from "../../components/admin/AdminLayout";
import { StatusBadge } from "../../components/StatusBadge";

const STATUSES = ["", "Received", "On route", "Completed", "On hold", "Cancelled"];

export default function AdminOrders() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  useEffect(() => { document.title = "Orders | Sambiva Admin"; }, []);
  const { data: orders = [] } = useQuery({ queryKey: ["admin-orders", status], queryFn: async () => (await api.get(`/admin/orders${status ? `?status=${encodeURIComponent(status)}` : ""}`)).data });

  return (
    <AdminLayout title="Orders">
      <div className="flex flex-wrap gap-2 mb-5">
        {STATUSES.map((s) => (
          <button key={s} data-testid={`order-filter-${s || "all"}`} onClick={() => setStatus(s)} className={`text-sm px-4 py-2 rounded-full font-medium ${status === s ? "bg-sambiva-green text-white" : "bg-white border border-black/10 text-sambiva-charcoal"}`}>{s || "All"}</button>
        ))}
      </div>
      <div className="bg-white rounded-2xl border border-black/5 overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead className="bg-[#f6f7f9] text-sambiva-muted text-left">
            <tr><th className="px-4 py-3 font-semibold">Order Number</th><th className="px-4 py-3 font-semibold">Customer</th><th className="px-4 py-3 font-semibold">Date</th><th className="px-4 py-3 font-semibold">Items</th><th className="px-4 py-3 font-semibold">Total</th><th className="px-4 py-3 font-semibold">Status</th></tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} data-testid={`admin-order-row-${o.order_number}`} onClick={() => navigate(`/admin/orders/${o.id}`)} className="border-t border-black/5 hover:bg-sambiva-cream/30 cursor-pointer">
                <td className="px-4 py-3 font-medium text-sambiva-charcoal">{o.order_number}</td>
                <td className="px-4 py-3 text-sambiva-muted">{o.company_name}</td>
                <td className="px-4 py-3 text-sambiva-muted">{new Date(o.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-3 text-sambiva-muted">{o.items.length}</td>
                <td className="px-4 py-3 font-medium">€{o.total.toFixed(2)}</td>
                <td className="px-4 py-3"><StatusBadge status={o.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <div className="p-10 text-center text-sambiva-muted">No orders found.</div>}
      </div>
    </AdminLayout>
  );
}
